import { Link } from "react-router-dom";

export const Wordmark = ({ className = "", asLink = true, testId = "navbar-wordmark" }) => {
  const inner = (
    <span
      className={`font-display font-semibold tracking-[-0.02em] text-foreground select-none inline-flex items-baseline transition-[text-shadow] duration-300 hover:[text-shadow:0_0_18px_rgba(0,212,255,0.45)] ${className}`}
    >
      CloudService
      <span className="text-[0.62em] ml-0.5 text-[#00d4ff] font-mono-cs font-normal">.hr</span>
    </span>
  );
  if (!asLink) return <span data-testid={testId}>{inner}</span>;
  return (
    <Link to="/" data-testid={testId} aria-label="CloudService.hr Startseite" className="focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring rounded-md">
      {inner}
    </Link>
  );
};
